<template>
    <div>
        <div class="popup">
            <div class="popup-inner">
                <v-card
                        class="mx-auto"
                        max-width="1000"
                        min-width="720"
                >
                    <button @click="close()" class="mr-2 close"
                            style="background-color: transparent; color: black; width: 25px; height: 25px; border-radius: 25px; position: absolute; right: 0;  top: 0;margin-top: 5px; float:right;">
                        <font-awesome-icon icon="close"/>
                    </button>
                    <div v-if="message" class="alert alert-danger" role="alert">
                        {{ message }}
                    </div>
                    <div class="submit-form">
                        <h3 class="subtitle is-4" style="margin-top: 30px;">Gruppe Erstellen</h3>
                        <Form v-model="data" @submit.prevent="saveCompany">
                            <v-row>
                                <v-col>
                                    <v-responsive
                                            class="mx-auto"
                                            max-width="344"
                                    >
                                        <v-text-field
                                                label="Name"
                                                id="CompanyName"
                                                v-model="this.name"
                                                placeholder=""
                                                type="text"
                                                variant="outlined"
                                                :rules="[required]"
                                        />
                                    </v-responsive>
                                </v-col>
                            </v-row>
                            <v-btn @click="saveCompany()" class="mb-4"
                                   :disabled="isDataComplete()"
                                   style="background-color: var(--merkur-bg-color);  color: white; width:120px;">Speichern
                            </v-btn>
                            <v-btn @click="close()" class="mb-4"
                                   style="background-color: red; border: 3px solid red; color: white; float: right; width:120px;">
                                Abbrechen
                            </v-btn>
                        </Form>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyDataService from "@/services/company.service";

export default {
  name: "CreateCompany",
  props: ['TogglePopup'],
  data() {
    return {
      name:null,
      message:"",
    }
  },
  methods: {
    close() {
      this.TogglePopup();
    },
    isDataComplete() {
      return !(this.name);
    },
    required(v) {
      return !!v || 'Erforderlich'
    },
    saveCompany() {
      const data = {
        name: this.name,
      };
      CompanyDataService.createCompany(data).then(response => {
        this.$emit('updateCompanies', response.data)
        this.TogglePopup();
      }).catch(e => {
        this.message = "Name bereits vergeben!"
        console.log(e);
      });
    },
  }
}
</script>

<style scoped>

.popup {
    overflow-y: scroll;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.4);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;

    justify-content: center;
}

.popup-inner {
    padding: 32px;

    position: fixed;
    top: 20%;
}

v-card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
}

.submit-form {
    max-width: 700px;
    margin: auto;
}
</style>